export class WinMeterEvents {
    public static readonly COUNT_UP: symbol = Symbol('COUNT_UP');
    public static readonly STOP_AFTER_SHOWING_FINAL_VALUE: symbol = Symbol('STOP_AFTER_SHOWING_FINAL_VALUE');
    public static readonly STOP_FINAL_VALUE_TIMER: symbol = Symbol('STOP_FINAL_VALUE_TIMER');
    public static readonly SET_VALUE: symbol = Symbol('SET_VALUE');
    public static readonly RESTORE_VALUE: symbol = Symbol('RESTORE_VALUE');
    public static readonly SNAP_TO_FINAL_VALUE: symbol = Symbol('SNAP_TO_FINAL_VALUE');
    public static readonly STOP: symbol = Symbol('STOP');
}